// extracted by mini-css-extract-plugin
export default {"category":"CategoryEyebrow-module--category--zxh3L","colorDefault":"CategoryEyebrow-module--colorDefault--x-c2t","colorYellow":"CategoryEyebrow-module--colorYellow--0lHDa"};